import React from "react";
import ChatSelect from "../components/ChatSelect";

const Home = () => {
  return (
    <div className="home">
      <ChatSelect />
    </div>
  );
};

export default Home;
